import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent implements OnInit {

  imgPortfolio1 = require('../../../images/portfolio01.jpg');
  imgPortfolio2 = require('../../../images/portfolio02.jpg');
  imgPortfolio3 = require('../../../images/portfolio03.jpg');
  imgPortfolio4 = require('../../../images/portfolio04.jpg');
  imgPortfolio5 = require('../../../images/portfolio05.jpg');
  imgPortfolio6 = require('../../../images/portfolio06.jpg');
  imgPortfolio7 = require('../../../images/portfolio07.jpg');
  imgPortfolio8 = require('../../../images/portfolio08.jpg');
  imgPortfolio9 = require('../../../images/portfolio09.jpg');

  ngOnInit(): void {

  }

}
